
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","fill-rule":"evenodd","clip-rule":"evenodd"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.919 17.377L3.05 4H1a.997.997 0 01-1-1 1 1 0 011-1h3.45l5.469 15.025c.841.101 1.59.5 2.139 1.088l11.258-4.097.684 1.879-11.049 4.021A3.502 3.502 0 019.5 24a3.501 3.501 0 01-1.581-6.623zM9.5 19.188a1.313 1.313 0 11-.002 2.626 1.313 1.313 0 01.002-2.626zm5.799-12.29l4.767-1.735 2.736 7.517-11.406 4.152L8.66 9.314l4.759-1.732 1.325 3.639 1.879-.684-1.324-3.639zm.537-1.26L8.318 8.374 6.266 2.736 13.784 0l2.052 5.638z"}})])
          )
        }
      }
    